import { ITooltipAngularComp } from "ag-grid-angular";
import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "rask-matningsomfattning",
    templateUrl: "./matningsomfattning.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./matningsomfattning.component.scss"]
})
export class MatningsomfattningComponent implements ITooltipAngularComp {

    isHeader = false;
    data: any = {};

    agInit(params): void {
        this.isHeader = params.location === "header";
    }
}
